import { G_THEME, THEME_PREFIX } from '../../components/atoms/provider/Provider';
import { GHubThemeType, GHubThemeVariant } from './ghub-theme.type';

export const mapGHubThemeToCXTheme = (theme: GHubThemeType, variant: GHubThemeVariant): G_THEME => {
  if (theme === 'glacier') return G_THEME.GLACIER;
  if (theme === 'af') {
    if (variant === 'primary') return G_THEME.AF_PRIMARY;
    if (variant === 'secondary') return G_THEME.AF_SECONDARY;
  }
  return G_THEME.DEFAULT;
};

export const mapCXThemeToGHubTheme = (cxTheme: string): GHubThemeType => {
  switch (cxTheme) {
    case `${THEME_PREFIX}${G_THEME.GLACIER}`:
      return 'glacier';
    case `${THEME_PREFIX}${G_THEME.AF_PRIMARY}`:
    case `${THEME_PREFIX}${G_THEME.AF_SECONDARY}`:
      return 'af';
    default:
      return 'glacier';
  }
};
